/*
*   @site           Preloaded: Site
*   @function       Image Controller
*   @author         Last17
*   @copyright      Copyright 2025, Preloaded.com
*   @version        0.01
*
*********************************************************************************************/


//-----------------------------------------------
// Imports
//-----------------------------------------------
import inView from 'in-view';

//-----------------------------------------------
// Class Definition
//-----------------------------------------------
class _ImageController {

  //-----------------------------------------------
  // Constructor
  //-----------------------------------------------
  constructor() {
  }


  //-----------------------------------------------
  // Init
  //-----------------------------------------------
  init() {
    //Index the images in the page
    this.indexImages(document.querySelectorAll('.image'));

    //Add an in-view listener to all of the images
    inView('.image').on('enter', function(el) {
      this.itemInView(el);
    }.bind(this));

    //Logos
    inView('.logo-svg').on('enter', function(el) {
      el.classList.add('in-view');
    }.bind(this));
  }


  //-----------------------------------------------
  // Index the images in the page
  //-----------------------------------------------
  indexImages(elements) {
    //Vars
    let imageType, alignX, alignY, inner;

    //Loop
    for(let i = 0; i < elements.length; i++) {
      if(!elements[i].getAttribute('data-image-status')) {
        if(elements[i].querySelectorAll('.image__obj').length) {
          //Set flag to stop it being processed again
          elements[i].setAttribute('data-image-status', 'processed');
         
          //Read the INNER HTML element and calculate the imagetype
          inner = elements[i].querySelector('.image__obj');
          imageType = (inner.nodeName === 'IMG') ? 'image' : 'background';
          
          //Custom alignment (used on WORK and BLOG indexes)
          if(elements[i].getAttribute('data-image-align-x') || elements[i].getAttribute('data-image-align-y')) {
            alignX = elements[i].getAttribute('data-image-align-x') || '50%';
            alignY = elements[i].getAttribute('data-image-align-y') || '50%';
            inner.style['background-position'] = alignX + ' ' + alignY;
            inner.style['object-position'] = alignX + ' ' + alignY;
          }

          //Is the image loaded?
          if(imageType === 'image') {
            //ACt
            if(!inner.complete || inner.naturalWidth <= 0 || inner.naturalHeight <= 0) {

              //Add a loader
              if(elements[i].getAttribute('data-image-loader')) {
                this.loaderAdd(elements[i]);
              }
              
              //Listen for load event instead
              inner.onload = function(wrapper) {
                setTimeout(function(wrapper) {
                  //Done
                  this.loadElementComplete(wrapper);
                }.bind(this, wrapper), 250);
              }.bind(this, elements[i]);
            } else {
              //Already loaded!
              this.loadElementComplete(elements[i]);
            }
          } else {
            //Add a loader
            if(elements[i].getAttribute('data-image-loader')) {
              this.loaderAdd(elements[i]);
            }

            //Background image, so we can't detect load easily
            elements[i].classList.add('loaded');
          }
        } else {
          console.log('Missing image holder');
        }
      }
    }
  }


  //-----------------------------------------------
  // Load complete
  //-----------------------------------------------
  loadElementComplete(item) {
    //Loaded
    item.classList.add('loaded');

    //If the parent element is an 'author', then we add a loaded class to that as well so we can fade the background back
    if(item.parentElement && item.parentElement.classList.contains('portrait')) {
      item.parentElement.classList.add('transparent');
    }
  }



  //-----------------------------------------------
  // Item In View
  //-----------------------------------------------
  loaderAdd(element) {
    let logo = document.createElement('div');
    logo.innerHTML = '<span></span><span></span><span></span>';
    logo.classList.add('loader-logo');
    element.prepend(logo);

    //Tint the background, unless specified not to
    if(!element.getAttribute('data-image-loader-no-background')) {
      element.classList.add('has-loader');
    }
    
  }


  //-----------------------------------------------
  // Item In View
  //-----------------------------------------------
  itemInView(element) {
    if(!element.classList.contains('in-view')) {
      //Set to in view
      element.classList.add('in-view');
    }
  }

}


//--------------------------------------------------------------------------
//  Export
//--------------------------------------------------------------------------
const ImageController = new _ImageController();
export default ImageController;